import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/karantina';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Fetch all inventory summaries
 */
export const fetchSummaries = async () => {
  const response = await api.get('/summaries');
  return response.data;
};

/**
 * Fetch available report types
 */
export const fetchReportTypes = async () => {
  const response = await api.get('/reports/types');
  return response.data;
};

/**
 * Fetch vendor report types (dynamic from DB)
 */
export const fetchVendorReportTypes = async () => {
  const response = await api.get('/reports/vendors');
  return response.data;
};

/**
 * Fetch all products report
 */
export const fetchAllProductsReport = async () => {
  const response = await api.get('/reports/all');
  return response.data;
};

/**
 * Fetch toxic products report
 */
export const fetchToxicReport = async () => {
  const response = await api.get('/reports/toxic');
  return response.data;
};

/**
 * Fetch report by type (generic)
 */
export const fetchReportByType = async (type) => {
  const response = await api.get(`/reports/by-type/${type}`);
  return response.data;
};

/**
 * Fetch created items report
 */
export const fetchCreatedItemsReport = async () => {
  const response = await api.get('/reports/created-items');
  return response.data;
};

/**
 * Fetch storage details
 */
export const fetchStorageDetails = async () => {
  const response = await api.get('/storage/details');
  return response.data;
};

/**
 * Fetch report by type - unified function
 */
export const fetchReport = async (type) => {
  // Special cases
  if (type === 'all') return fetchAllProductsReport();
  if (type === 'toxic') return fetchToxicReport();
  if (type === 'apoGm') return fetchCreatedItemsReport();
  
  // Generic report by type
  return fetchReportByType(type);
};

export default api;
